export default {
  error: state => state.error,
  success: state => state.success,
  loading: state => state.loading,
  agmPresence: state => state.agmPresence,
  presence: state => state.presence,
  exportLoading: state => state.exportLoading,
  exportSuccess: state => state.exportSuccess,
  downloadLink: state => state.downloadLink,
  totalQuotePart: state => state.totalQuotePart,
};



// WEBPACK FOOTER //
// ./src/components/Syndicates/Syndicate/Reports/AGM/getters.js